
import divSpan from '@/components/DivSpan';
import materialQuotaManageTp from '@/components/page-temporary/material-quota-manage-tp'
import Popup from 'vux/src/components/popup/index.vue'


export default {
name: "material-quota-manage",
components: {
divSpan,
materialQuotaManageTp,
Popup
},
data() {
return {
refresh:true,
wrapperHeight: 0,
allLoaded: false,
showDetail: false,
config: {
title: '配额管理',
url: 'api/quota-control/page',
workflowSearchBean: {},
fixRules: [],
inputCondition: {
placeholder: '物料编号/名称',
searchCondition: 'key',
rules: [{
field: "material.matCode-material.matName",
option: "LIKE_ANYWHERE"
}]
},
},
searchData: {},
detailDto: {},
list: [],
}
},
methods: {
goDetail(data){
this.detailDto=data;
this.showDetail=!this.showDetail;
},
getList(e,met,bol){
this.$nextTick(()=>{
if(bol){
this.list = this.list.concat(e);
}else{
this.list = e;
}
if(met === 'top'){
this.$refs.loadmore.onTopLoaded();
}
if(met === 'bottom'){
this.$refs.loadmore.onBottomLoaded();
}
})
},
init: function () {

this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
},
loadTop() {
this.$refs.header.getlist(true);
},
loadBottom() {
this.$refs.header.getMore();
},
closeQual(){
this.showDetail = false;
}
},
mounted() {
this.init()
this.$refs.header.getlist();
}
}



// WEBPACK FOOTER //
// ./src/page/material-quota-manage/material-quota-manage.vue